import React, {Component} from 'react';
import './style.css';

export default class ProductPanel extends Component {
	render() {
		return (
			<div className={"com-productpanel " + this.props.className}>
				<div className="p-header">
					{this.props.title}
				</div>
				<div className="p-body">
					{this.props.children}
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/03-components/ProductPanel/index.js